import { initOpenTelemetry } from './otel';
import { API_ENDPOINT } from '../config';

const TRACKER_NAME = 'originations-ui';

const OTEL_PROPAGATION_ENABLED = [new RegExp(API_ENDPOINT)];
const OTEL_TRACING_DISABLED = [
  /www.google-analytics.com/,
  /dataplane.rum.([\w-]+).amazonaws.com/,
  /api.trustpilot.com/,
  /api.([\w-]+).amplitude.com/,
  /([\w-]+).hotjar.io/,
  /api.honeybadger.io/,
  /stats.g.doubleclick.net/,
  /ads.linkedin.com/,
  /wa.fundingcircle.com/,
  /optimonk.com/
];
const REACT_APP_OTEL_COLLECTOR =
  window._ENV_CONFIG_VARS.REACT_APP_OTEL_COLLECTOR;

export function initOtel() {
  initOpenTelemetry(
    TRACKER_NAME,
    REACT_APP_OTEL_COLLECTOR,
    'uk',
    OTEL_PROPAGATION_ENABLED,
    OTEL_TRACING_DISABLED
  );
}
